module.exports = __webpack_public_path__ + "static/five-bw-726e4b038e6c02d21f954151bd8b4027.jpg";